// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AskGetabstractAnalyticsEventVariant } from "../schema";

export function serialize_AskGetabstractAnalyticsEventVariant_internal(value: AskGetabstractAnalyticsEventVariant): unknown {
  return ((value: "default_variant" | "qa_triggered_from_search" | "qa_demo"): unknown => {
    return value;
  })(value);
}
export function serialize_AskGetabstractAnalyticsEventVariant(obj: AskGetabstractAnalyticsEventVariant): string {
  return renderJsonWithNumbersAsBigint(serialize_AskGetabstractAnalyticsEventVariant_internal(obj));
}
export function deserialize_AskGetabstractAnalyticsEventVariant_internal(value: unknown): ParserResult<AskGetabstractAnalyticsEventVariant> {
  return ((value: unknown): ParserResult<"default_variant" | "qa_triggered_from_search" | "qa_demo"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnalyticsEventVariant]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "default_variant":
        return { success: true, value: "default_variant" };
      case "qa_triggered_from_search":
        return { success: true, value: "qa_triggered_from_search" };
      case "qa_demo":
        return { success: true, value: "qa_demo" };
      default:
        return { success: false, reason: `[#/components/schemas/AskGetabstractAnalyticsEventVariant]: '${value}' expected to be enum, one of 'default_variant, qa_triggered_from_search, qa_demo'.` };
    }
  })(value);
}
export function deserialize_AskGetabstractAnalyticsEventVariant(str: string): ParserResult<AskGetabstractAnalyticsEventVariant> {
  return deserialize_AskGetabstractAnalyticsEventVariant_internal(parseJsonWithNumbersAsBigint(str));
}
